module.exports = __webpack_public_path__ + "media/src/images/send_gift_arrow-a0a9ba7d96d9b7076d8096d60bc67446.svg";